import { Navigate, Outlet } from 'react-router-dom';
import { useApp } from '@/context/app-context';

export function RequireAuth() {
  const { state } = useApp();
  if (!state.gapiToken) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
